import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClickOutsideModule } from 'ng-click-outside';
import { GenericModalComponent } from './generic-modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { DaProgressiveImageModule } from '../da-progressive-image';
import { DaButtonModule } from '../da-button';
import { DaLinkModule } from '../da-link';
import { PipesModule } from '@draeger-academy/common';

@NgModule({
    declarations: [GenericModalComponent],
    imports: [CommonModule, PipesModule, DaLinkModule, ClickOutsideModule, DaButtonModule, DaProgressiveImageModule, TranslateModule],
    exports: [GenericModalComponent]
})
export class GenericModalModule {}
